module.exports = __webpack_public_path__ + "img/626.9dcb998f.jpg";